import { render, staticRenderFns } from "./EmbedMedia.vue?vue&type=template&id=65da0656&"
import script from "./EmbedMedia.vue?vue&type=script&lang=js&"
export * from "./EmbedMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports